import { motion } from 'framer-motion';

const stats = [
  { stat: '15 min', label: 'Average fill time' },
  { stat: '10+', label: 'Licensed pharmacists' },
  { stat: '100%', label: 'Verified medications' },
  { stat: '24/7', label: 'Support available' },
];

export default function PharmacyIntro() {
  return (
    <section aria-labelledby="intro-heading" className="mb-20">
      {/* Image + Text split */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-14">
        <motion.div
          initial={{ opacity: 0, scale: 0.98 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.75, ease: 'easeOut' }}
          className="rounded-lg overflow-hidden w-full h-80 lg:h-[420px] flex-shrink-0"
        >
          <img
            src="https://readdy.ai/api/search-image?query=professional%20licensed%20pharmacist%20in%20white%20coat%20reviewing%20prescription%20with%20elderly%20patient%20at%20counter%20modern%20well-lit%20pharmacy%20teal%20and%20white%20color%20scheme%20warm%20friendly%20interaction%20personalized%20pharmaceutical%20care%20Toronto%20setting&width=700&height=500&seq=phintro-main-img&orientation=landscape"
            alt="Thornhill Drug-Mart pharmacist providing personalized care"
            className="w-full h-full object-cover object-top"
            width={700}
            height={500}
            loading="lazy"
            decoding="async"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 22 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: 'easeOut' }}
        >
          <p className="text-xs font-semibold text-primary-600 uppercase tracking-[0.15em] mb-4">
            Thornhill&apos;s Trusted Pharmacy
          </p>
          <h2
            id="intro-heading"
            className="text-3xl lg:text-[2.1rem] font-bold text-foreground-950 leading-snug mb-5"
          >
            Comprehensive Care for Every Prescription Need
          </h2>
          <p className="text-foreground-500 leading-relaxed text-[0.94rem] mb-4">
            At Thornhill Drug-Mart, we understand that every patient&apos;s health journey is unique.
            Our licensed pharmacists provide personalized pharmaceutical care tailored to your specific
            needs — whether you require prescription dispensing, <a href="/addiction-services" className="text-primary-600 hover:text-primary-700 underline underline-offset-2 transition-colors font-semibold">medication-assisted treatment (MAT)</a>,
            over-the-counter medication guidance, or minor ailment prescribing for 40+ conditions without
            needing a doctor.
          </p>
          <p className="text-foreground-500 leading-relaxed text-[0.94rem]">
            We serve <strong className="text-foreground-700 font-semibold">Thornhill</strong>, North York,
            Richmond Hill, and Vaughan — combining modern pharmacy technology with compassionate,
            face-to-face care so you can feel confident in every step of your treatment.
          </p>
        </motion.div>
      </div>

      {/* Stats strip */}
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-background-200 border border-background-200 bg-background-50 rounded-lg overflow-hidden"
      >
        {stats.map((s, i) => (
          <div key={i} className="px-7 py-6 flex flex-col gap-1">
            <strong className="text-2xl font-bold text-foreground-950 tracking-tight">{s.stat}</strong>
            <span className="text-xs text-foreground-500 font-medium">{s.label}</span>
          </div>
        ))}
      </motion.div>
    </section>
  );
}
